/**
 * Pill Section
 * @function pillSection
 * @param {event} e 
 */

window.pillSection = function (e) {

    if (e) {
        e.stopPropagation();

        let pillBtn = e.target;
        let pillBtns = pillBtn.parentNode.querySelectorAll('.pill-button');
        let paneNum = pillBtn.getAttribute('data-section');
        let pillBox = pillBtn.parentNode.parentNode.parentNode;
        let pillSlider = pillBtn.parentNode.querySelector('.button-slider');

        //  toggle pill slider class
        if (!pillBtn.classList.contains('active')) {
            if (pillSlider.classList.contains('on')) {
                pillSlider.classList.remove('on');
                pillSlider.style.left = '0';
            } else {
                pillSlider.classList.add('on');
                pillSlider.style.left = 'calc(100% - ' + pillBtn.offsetWidth + 'px)';
            }
        }

        //  set all buttons to inactive
        pillBtns.forEach(function (btn) {
            btn.classList.remove('active');
        });

        //  set active button
        pillBtn.classList.add('active');

        //  set slider width
        pillSlider.style.width = pillBtn.offsetWidth + 'px';

        //  hide all panes
        pillBox.querySelectorAll('.tab-section').forEach(function (pane) {
            pane.style.display = 'none';
        });

        pillBox.querySelectorAll('.tt-tab-section').forEach(function (pane) {
            pane.style.display = 'none';
        });

        //  show the active pane
        pillBox.querySelectorAll('.section-' + paneNum)[0].style.display = 'block';

        //  set all pills to inactive
        pillBox.querySelectorAll('.tab-section-pills i').forEach(function (pill) {
            pill.classList.remove('active');
        });

    }
    //  set active pill
    //pillBox.querySelectorAll('.pill-' + paneNum)[0].classList.add('active');
}